var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1200 1200",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".clock_svg__st0{fill:#333}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clock_svg__st0",
    d: "M396.6,126c-33.2-27-75.2-43.5-120.2-43.5C169,82.5,81.9,173.7,81.9,286.2c0,47.2,15.6,90.7,41.5,125.4 C175.8,283.6,273.7,180.9,396.6,126z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "clock_svg__st0",
    d: "M599.7,133.2c-259.2,0-469.6,220.3-469.6,491.9c0,130.1,48.7,248.3,128,336.4l-65.8,68.9 c-13.5,14.5-18.1,36.3-10.4,55.5c7.8,19.2,25.4,31.6,45.1,31.6c13,0,24.9-5.7,34.2-15l70-73.6c76.2,55.5,168.5,88.1,268,88.1 c100,0,192.3-32.7,268.5-88.6l70.5,74.1c9.3,9.3,21.3,14.5,34.2,14.5c26.9,0,48.2-22.3,48.2-50.3c0-13.5-5.2-26.4-14-35.8 L940.8,962c79.3-87.6,128.6-206.3,128.6-336.9C1069.3,353.5,859.4,133.2,599.7,133.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "clock_svg__st0",
    d: "M927.8,83c-44.6,0-85.5,16.1-117.7,42.5c119.7,53.4,215.6,153.9,266.9,279.4c25.4-34.2,41-76.7,41-122.8 C1118.1,172.1,1033.1,83,927.8,83z"
  })));
};
export default SvgClock;